import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/tokens.css';
import './styles/ui.css';
import './theme/palette.css';
import './theme/theme-v2.css';
import './styles/shadcn-skin.css';
import './styles/gtpl.css';
import App from './App';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';

// Smooth mouse-wheel scrolling for the page (touch scrolling stays native).
// allowNestedScroll leaves modals, the sidebar and other inner scroll areas to
// the browser; the map keeps the wheel for zooming.
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  new Lenis({
    autoRaf: true,
    allowNestedScroll: true,
    prevent: (node) => node.classList.contains('leaflet-container'),
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

// A phone app left open keeps running the bundle it loaded, so after a deploy it shows the old UI.
// When the app comes back to the foreground, compare its bundle with the one the server now serves
// and reload if they differ (never mid-use: only on return from background, at most once a minute).
let lastBuildCheck = 0;
document.addEventListener('visibilitychange', async () => {
  if (document.visibilityState !== 'visible' || Date.now() - lastBuildCheck < 60000) return;
  lastBuildCheck = Date.now();
  try {
    const mine = document.querySelector('script[src*="/static/js/main."]')?.getAttribute('src');
    const html = await (await fetch('/', { cache: 'no-store' })).text();
    const live = html.match(/\/static\/js\/main\.[\w]+\.js/)?.[0];
    if (mine && live && !mine.endsWith(live)) {
      const regs = (await navigator.serviceWorker?.getRegistrations()) || [];
      await Promise.all(regs.map((r) => r.update().catch(() => {})));
      window.location.reload();
    }
  } catch { /* offline: keep current UI */ }
});
